import { call, put, fork, join } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'
import { attemptRefreshToken } from './userSaga'

export function* getPaymentInfoGuestSaga({ payload: itemId }) {
  try {
    yield put({ type: types.FETCHING })
    const res = yield call(api.requestGetPaymentInfoGuest, itemId)
    yield put({
      type: types.GET_PAYMENT_INFO_GUEST_SUCCESS,
      payload: {
        ...res.data,
        cream_item_id: itemId,
      },
    })
  } catch (err) {
    console.error('getPaymentInfoGuestSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.GET_PAYMENT_INFO_GUEST_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getPaymentInfoMemberSaga({ payload: itemId }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)
    const res = yield call(api.requestGetPaymentInfoMember, itemId)
    yield put({
      type: types.GET_PAYMENT_INFO_MEMBER_SUCCESS,
      payload: {
        ...res.data,
        cream_item_id: itemId,
      },
    })
  } catch (err) {
    console.error('getPaymentInfoMemberSaga', err)
    try {
      if (
        err.data.errno ===
          'ERR_AIFIAN_PRODUCT_SERVICE_CREAM_SENDER_RECEIVER_IDENTICAL' ||
        err.data.errno ===
          'ERR_AIFIAN_PAYMENT_SERVICE_CREAM_SENDER_RECEIVER_IDENTICAL'
      ) {
        yield put({ type: types.GET_PAYMENT_INFO_MEMBER_ERROR_IDENTICAL })
      } else if (
        err.data.errno ===
        'ERR_AIFIAN_PAYMENT_SERVICE_SLASH_AIFI_OWNER_EXCLUSIVE'
      ) {
        yield put({
          type: types.GET_PAYMENT_INFO_MEMBER_ERROR_AIFI_OWNER_EXCLUSIVE,
        })
      } else {
        const message = getErrorMessage(err)
        yield put({ type: types.GET_PAYMENT_INFO_MEMBER_ERROR })
        yield put(setSnackbarErrorAction(message))
      }
    } catch (ignored) {
      // continue
    }
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
